export default __webpack_public_path__ + "static/media/korrencyCoin.bc93033d.svg";